import { useState, type ReactNode } from "react";

import { Footer } from "./Footer";
import { Header } from "./Header";
import { ShellContext } from "./shellContext";

type Props = { children: ReactNode };

export function AppShell({ children }: Props) {
  const [query, setQuery] = useState("");
  return (
    <ShellContext.Provider value={{ query, setQuery }}>
      <div className="flex min-h-screen flex-col bg-slate-50">
        <Header query={query} onQueryChange={setQuery} />
        <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6">
          {children}
        </main>
        <Footer />
      </div>
    </ShellContext.Provider>
  );
}
